export default __webpack_public_path__ + "static/media/fox.3de8e6ff.svg";